import { Block, Para, Table, Bullets } from '../print/PrintBlocks';
import { DoDont } from '../DoDont';
import { ItemDaDocumentacao } from '../ItemDaDocumentacao';

export function ConteudoSection() {
  return (
    <div className="space-y-6">
      <ItemDaDocumentacao id="conteudo-linguagem">
        <Block>
          <Para>
            A interface é 100% em português do Brasil e fala a língua de quem opera: nada de
            mensagens técnicas, códigos internos ou termos em inglês na tela. Todo texto tem uma
            função — dizer o que aconteceu e o que fazer em seguida.
          </Para>
        </Block>
      </ItemDaDocumentacao>

      <ItemDaDocumentacao id="conteudo-vocabulario">
        <Block title="Vocabulário oficial">
          <Table
            head={['Use', 'Evite', 'Motivo']}
            rows={[
              [
                'Ordem de Serviço',
                'OS crua sem contexto',
                'O termo completo aparece em títulos; a sigla só em colunas estreitas.',
              ],
              ['Credenciado', 'Fornecedor, prestador', 'Termo previsto no edital e nos contratos.'],
              ['Apontamento', 'Lançamento, registro diário', 'Nome consagrado no processo mensal.'],
              [
                'Competência',
                'Mês de referência',
                'Vocabulário contábil usado por SME e Financeiro.',
              ],
              ['Enviar para análise', 'Submeter', 'Ação descreve o destino, não o verbo técnico.'],
              [
                'Não foi possível salvar',
                'Erro 500',
                'O usuário precisa da consequência, não do código.',
              ],
            ]}
          />
        </Block>
      </ItemDaDocumentacao>

      <ItemDaDocumentacao id="conteudo-mensagens-de-erro">
        <Block title="Mensagens de erro">
          <DoDont
            doText="Não foi possível enviar o apontamento porque a competência já foi fechada. Peça a reabertura ao Financeiro para seguir."
            dontText="Error: violation of constraint trg_competencia_selada on table apontamentos_celulas."
          />
        </Block>
      </ItemDaDocumentacao>

      <ItemDaDocumentacao id="conteudo-tom">
        <Block title="Tom por persona">
          <Bullets
            items={[
              'Gestor: objetivo e comparativo — números, variações e prazos.',
              'Fiscal: direto e imperativo — o que registrar agora, em poucas palavras.',
              'Financeiro: preciso e formal — competência, valores e base legal.',
              'Transportador: acolhedor e explicativo — o que falta, até quando e como resolver.',
            ]}
          />
        </Block>
      </ItemDaDocumentacao>

      <ItemDaDocumentacao id="conteudo-regras">
        <Block title="Regras de escrita">
          <Bullets
            items={[
              'Botões começam com verbo no infinitivo: Salvar, Enviar para análise, Rescindir termo.',
              'Confirmações críticas dizem o efeito, não a pergunta genérica: “Rescindir o termo TC-2026/014?”.',
              'Estados vazios sempre oferecem o próximo passo, nunca apenas “Nenhum registro”.',
              'Nada de travessões decorativos nem reticências desnecessárias em rótulos.',
              'Abreviações só quando o espaço exigir, e sempre com o nome completo disponível ao passar o mouse.',
            ]}
          />
        </Block>
      </ItemDaDocumentacao>
    </div>
  );
}
